// extracted by mini-css-extract-plugin
export default {"wrap":"Ya7gI","label":"sT3uG","labelNoBorder":"WfvMX","gift":"owCiP","scrollWrap":"ZcWig","stats":"Lj7w3"};